<template>
    <label
        class="flex flex-col"
        :class="disabled ? ['opacity-75'] : []"
        :for="name"
    >
        <p class="font-medium text-sm sm:text-base">
            <slot></slot>
        </p>
        <date-picker
            input-class="w-full h-9.2 px-2 text-sm focus:outline-none focus:border-2 focus:border-light-blue border-2 border-brown"
            popup-class="text-black"
            range-separator="-"
            :class="classes"
            :name="name"
            :type="type"
            format="YYYY-MM"
            valueType="YYYY-MM"
            v-model="datePickerInput"
        >
            <template v-slot:icon-calendar>
                <i class="fa-solid fa-calendar text-black"></i>
            </template>
            <template v-slot:icon-clear>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                >
                    <path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path>
                </svg>
            </template>
        </date-picker>
    </label>
</template>

<script>
// vue2-datepicker
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
export default {
    components: {
        DatePicker,
    },
    props: ["classes", "type", "value", "name", "disabled"],
    computed: {
        datePickerInput: {
            get: function () {
                return this.value;
            },
            set: function (value) {
                // console.log("set", value);
                this.$emit("change", value);
            },
        },
    },
};
</script>

<style>
.mx-datepicker {
    width: 100%;
}
.mx-btn {
    color: #000;
}
.mx-btn:hover {
    color: #00aad2;
    border-color: #00aad2;
}
.mx-datepicker-main {
    color: #000;
}
.mx-calendar-content .cell.active {
    background-color: #00aad2;
}
.mx-calendar-content .cell:hover {
    color: #00aad2;
}
.mx-icon-clear {
    top: 60%;
    right: 3px;
}
</style>